document.addEventListener('DOMContentLoaded', function () {
    const selectedWrapper = document.getElementById("selected-inserts");
    const hiddenInput = document.getElementById("insert-values");
    const insertContainer = document.getElementById("insert-buttons");
    const bundleMessageContainer = document.getElementById("bundle-message-container");
    if (hiddenInput && hiddenInput.name) {
        console.warn(`⚠️ The hidden input with ID 'insert-values' has a name attribute: '${hiddenInput.name}'. This will automatically add a property to the cart.`);
    }
    const MAX_TOTAL_INSERTS = 4;
    const mainAddToCartButton = document.querySelector('form[data-type="add-to-cart-form"] [name="add"]');
    const insertSelectionLabel = document.getElementById("insert-selection-label");
    const insertProgressBarFill = document.getElementById("insert-progress-fill");
    if (!selectedWrapper || !insertContainer || !hiddenInput || !insertSelectionLabel || !insertProgressBarFill || !bundleMessageContainer) {
      console.error("❌ Critical: Missing required HTML containers or UI elements for product-insert.js. Script aborted.");
      if(mainAddToCartButton) mainAddToCartButton.textContent = "Error Loading";
      return;
    }
    let selectedInserts = [];
    let previousBundleSize = null;
    function initializeBundleUI(initialFullSize) {
        if (!window.getVariantDetailsById || !window.getSimplifiedSize || !window.getDesignNameFromTitle || !window.insertVariantsBySize) {
            console.error("❌ Critical: Global helper functions or data not available for UI initialization. global-bundles.js might not have loaded correctly or populated data.");
            window.displayBundleMessage("Error: Core bundle data missing for UI. Please refresh or contact support.", 'error', 0);
            if (mainAddToCartButton) mainAddToCartButton.textContent = "Error Loading";
            return;
        }
        const dummyVariant = { selectedOptions: [{ name: 'Size', value: initialFullSize }] };
        const simplifiedInitialSize = window.getSimplifiedSize(dummyVariant);
        if (simplifiedInitialSize) {
            console.log("🎨 Initializing bundle UI with simplified size:", simplifiedInitialSize);
            renderInsertButtons(simplifiedInitialSize);
            updateUI();
        } else {
            console.warn(`Could not determine simplified size for initial bundle variant: '${initialFullSize}'. Inserts may not display correctly.`);
            window.displayBundleMessage("Warning: Bundle size could not be determined. Inserts may not display correctly.", 'warning');
        }
    }
    document.addEventListener('bundle:data-loaded', (event) => {
        console.log("👂 'bundle:data-loaded' event received in product-insert.js. Data is ready for UI.");
        initializeBundleUI(event.detail.initialSize); 
    });
    document.addEventListener('bundle:clear-selection', () => {
        selectedInserts = [];
        console.log("Cleared selected inserts due to cart submission.");
        updateUI();
    });
    // Keep Add to Cart (and the Buy with Shop / dynamic checkout buttons, which the theme CSS
    // locks while Add to Cart is disabled) locked unless exactly 4 inserts are selected.
    // global-bundles-single.js re-enables Add to Cart in its submit "finally" block, which runs
    // after the selection is cleared on a successful add, leaving Buy with Shop clickable with
    // no inserts. This re-syncs the button state whenever it becomes enabled with fewer than 4.
    if (mainAddToCartButton) {
        new MutationObserver(() => {
            if (!mainAddToCartButton.disabled && selectedInserts.length !== MAX_TOTAL_INSERTS) {
                document.dispatchEvent(new CustomEvent('bundle:inserts-updated', {
                    detail: { selectedInserts: selectedInserts }
                }));
            }
        }).observe(mainAddToCartButton, { attributes: true, attributeFilter: ['disabled'] });
    }
    const variantSelectInput = document.querySelector('[name="id"]');
    if (variantSelectInput) {
        let currentMainProductId = Number(variantSelectInput.value);
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    const newMainProductId = Number(variantSelectInput.value);
                    if (newMainProductId !== currentMainProductId) {
                        currentMainProductId = newMainProductId;
                        console.log("MutationObserver detected main product variant ID change to:", newMainProductId);
                        const variant = window.meta.product.variants.find(v => v.id === Number(newMainProductId));
                        if (variant) {
                            const newMainProductBundleSize = variant.option1 ? variant.option1.trim() : null;
                            const newMainProductBundleColor = variant.option2 ? variant.option2.trim() : null;
                            document.dispatchEvent(new CustomEvent('bundle:main-variant-change', {
                                detail: {
                                    size: newMainProductBundleSize,
                                    color: newMainProductBundleColor
                                }
                            }));
                            console.log(`Updated global bundle options to Size: '${newMainProductBundleSize}', Color: '${newMainProductBundleColor}'`);
                            const dummyVariant = { selectedOptions: [{ name: 'Size', value: newMainProductBundleSize }] };
                            const simplifiedSize = window.getSimplifiedSize(dummyVariant);
                            if (simplifiedSize) {
                                renderInsertButtons(simplifiedSize);
                            } else {
                                console.warn(`Could not determine simplified size for new primary product variant ${newMainProductId} after update.`);
                                window.displayBundleMessage("Warning: Bundle size could not be determined. Inserts may not display correctly.", 'warning');
                            }
                        } else {
                            console.warn(`Primary product variant with ID ${newMainProductId} not found in window.meta.product.variants.`);
                            window.displayBundleMessage("Error: Selected main product variant not found. Please refresh.", 'error');
                        }
                    }
                }
            }
        });
        observer.observe(variantSelectInput, { attributes: true });
    } else {
        console.error("❌ variantSelectInput not found for MutationObserver setup. Variant changes won't update inserts.");
        window.displayBundleMessage("Critical Error: Product variant selector missing. Bundle features may be unavailable.", 'error', 0);
    }
    function updateUI() {
      window.clearBundleMessage();
      selectedWrapper.innerHTML = '';
      const hiddenInputParts = [];
      selectedInserts.forEach((idGid, index) => {
          const variant = window.getVariantDetailsById(idGid);
          if (variant) {
              const simplifiedSize = window.getSimplifiedSize(variant);
              hiddenInputParts.push(`${simplifiedSize} ${window.getDesignNameFromTitle(variant.title)}`);
          }
      });
      hiddenInput.value = hiddenInputParts.join(', ');
      selectedInserts.forEach((variantIdGid, index) => {
        const variant = window.getVariantDetailsById(variantIdGid);
        if (variant) {
          const tag = document.createElement('div');
          tag.className = 'insert-tag button button--small';
          const simplifiedSize = window.getSimplifiedSize(variant);
          tag.innerHTML = `${simplifiedSize} ${window.getDesignNameFromTitle(variant.title)} <span class="remove-tag" data-index="${index}">&times;</span>`;
          selectedWrapper.appendChild(tag);
        }
      });
      document.querySelectorAll(".remove-tag").forEach(el => {
        el.addEventListener("click", (e) => {
          const indexToRemove = parseInt(e.target.dataset.index);
          if (indexToRemove > -1 && indexToRemove < selectedInserts.length) {
            selectedInserts.splice(indexToRemove, 1);
            console.log(`- Removed insert at index ${indexToRemove}. New total: ${selectedInserts.length}`);
            updateUI();
          }
        });
      });
      const currentTotalQuantityOfInserts = selectedInserts.length;
      if (insertSelectionLabel) {
          const remainingSlots = MAX_TOTAL_INSERTS - currentTotalQuantityOfInserts;
          if (currentTotalQuantityOfInserts === MAX_TOTAL_INSERTS) {
              insertSelectionLabel.textContent = "All 4 Inserts Selected!";
              insertSelectionLabel.style.color = "#28a745";
          } else if (currentTotalQuantityOfInserts > 0) {
              insertSelectionLabel.textContent = `Choose ${remainingSlots} more inserts:`;
              insertSelectionLabel.style.color = "";
          } else {
              insertSelectionLabel.textContent = `Choose your ${MAX_TOTAL_INSERTS} Inserts:`;
              insertSelectionLabel.style.color = "";
          }
      }
      if (insertProgressBarFill) {
          const progressPercentage = (currentTotalQuantityOfInserts / MAX_TOTAL_INSERTS) * 100;
          insertProgressBarFill.style.width = `${progressPercentage}%`;
          if (currentTotalQuantityOfInserts === MAX_TOTAL_INSERTS) {
              insertProgressBarFill.classList.add('complete');
          } else {
              insertProgressBarFill.classList.remove('complete');
          }
      }
      document.dispatchEvent(new CustomEvent('bundle:inserts-updated', {
          detail: {
              selectedInserts: selectedInserts
          }
      }));
      document.querySelectorAll('.insert-button').forEach(btn => {
          const variantGid = btn.dataset.variantId;
          let originalVariant = window.getVariantDetailsById(variantGid);
          if (originalVariant && !originalVariant.availableForSale) {
              btn.disabled = true;
              btn.classList.add('sold-out-insert');
              btn.classList.remove('disabled-by-limit');
          } else {
              if (currentTotalQuantityOfInserts < MAX_TOTAL_INSERTS) {
                  btn.disabled = false;
                  btn.classList.remove('disabled-by-limit');
              } else {
                  btn.disabled = true;
                  btn.classList.add('disabled-by-limit');
              }
          }
      });
    }
    function updateInsertSelection(variantGid) {
      const currentTotalQuantityOfInserts = selectedInserts.length;
      if (currentTotalQuantityOfInserts >= MAX_TOTAL_INSERTS) {
          window.displayBundleMessage(`You can only select a total of ${MAX_TOTAL_INSERTS} inserts.`);
          console.warn(`🚫 Limit reached. Cannot add more inserts. Current total: ${currentTotalQuantityOfInserts}. Max allowed: ${MAX_TOTAL_INSERTS}`);
          return;
      }
      selectedInserts.push(variantGid);
      console.log(`+ Added insert (ID: ${variantGid}). Total selected: ${selectedInserts.length}.`);
      updateUI();
    }
    function renderInsertButtons(newSize) {
      insertContainer.innerHTML = '';
      window.clearBundleMessage();
      if (previousBundleSize && previousBundleSize !== newSize) {
          selectedInserts = [];
          console.log(`Bundle size changed from ${previousBundleSize} to ${newSize}. Clearing selected inserts.`);
      } else if (!previousBundleSize && selectedInserts.length > 0) {
          console.log("Initial load or bundle size not yet set, and inserts were selected. Clearing selected inserts.");
          selectedInserts = [];
      }
      previousBundleSize = newSize;
      updateUI();
      if (!window.insertVariantsBySize || !window.insertVariantsBySize[newSize] || window.insertVariantsBySize[newSize].length === 0) {
        console.warn(`⚠️ No insert variants found for size: ${newSize}.`);
        insertContainer.innerHTML = '<p>No inserts available for this size.</p>';
        if (mainAddToCartButton) {
            mainAddToCartButton.disabled = true;
            mainAddToCartButton.textContent = "No Inserts for this Size";
        }
        return;
      }
      window.insertVariantsBySize[newSize].forEach(variant => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "insert-button button button--small light";
        btn.dataset.value = variant.title;
        btn.dataset.variantId = variant.id;
        btn.dataset.size = newSize;
        btn.textContent = window.getDesignNameFromTitle(variant.title);
        const currentVariantId = variant.id;
        btn.addEventListener("click", () => {
          if (!btn.disabled) {
            updateInsertSelection(currentVariantId);
          }
        });
        insertContainer.appendChild(btn);
      });
      console.log(`✅ Insert buttons rendered for size ${newSize}.`);
      requestAnimationFrame(() => {
          updateUI();
      });
    }
  });